<template>
<div class="c-gallery">
    <div class="c-gallery-imagearea">
        <div class="iframe-container" v-if="currentImage.iframe">
            <iframe class="c-gallery-iframe" :src="currentImage.iframeSrc" frameborder="0" allowfullscreen="allowfullscreen" allowvr="true"></iframe>
        </div>
        <figure v-else :class="['c-gallery__main-image', { 'c-gallery__main-image-ie11-fix' : images.length === 1 }]" :id="`gallery${randomNumber}`" :aria-live="isLive !== '' ? isLive : false" :aria-atomic="isAtomic !== '' ? isAtomic : false" :aria-labelledby="currentId">
            <img :src="currentImage.imageUrl" :alt="currentImage.text" :title="currentImage.text" />
            <div class="c-gallery-imagetext-labelarea" v-if="currentImage.labelText" :style="`background-color: ${currentImage.labelColor}`">
                <p class="c-gallery-imagetext-labelarea--text">{{currentImage.labelText}}</p>
            </div>
            <div class="c-gallery-imagetext" v-if="currentImage.imageText"><p>{{currentImage.imageText}}</p></div>
        </figure>
    </div>
    <v-gallery-image-scroller-small
    v-if="images.length >= minNumToShow"
    @selectImage="selectImage" 
    :images="images" 
    :thumbnail-width="thumbnailWidth" 
    :aria-controls="`gallery${randomNumber}`" 
    :controls-live-region="true" 
    min-num-to-show="2"></v-gallery-image-scroller-small>
</div>
</template>

<script>
import VGalleryImageScrollerSmall from '../../components/gallery-image-scroller-small/VGalleryImageScrollerSmall.vue';
import VArticle from '../article/VArticle.vue';
export default {
    name: 'VGallery',
    components: {
        VGalleryImageScrollerSmall,
        VArticle,
        VArticle
    },
    props: {
        images: {
            type: Array,
            default: () => []
        },
		thumbnailWidth: {
			type: Number,
			default: 21
		}
    },
    data() {
        return {
            currentIndex: 0,
            isLive: (this.images.length > 1) ? 'polite' : '',
            isAtomic: (this.images.length > 1) ? 'true' : '',
			randomNumber: Math.random(),
            minNumToShow: 2,
        }
    },
    computed: {
        currentImage() {
            return this.images[this.currentIndex];
        },
        currentId() {
            if (this.images.length > 1) {
                return (this.images[this.currentIndex]) ? this.images[this.currentIndex].id : this.images[0].id;
            }
        },
    },
    methods: {
        selectImage(index, id) {
            this.currentIndex = index;
        },
    },
}
</script>
